import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Saludo animado tras confirmar pedido (checkout + menú).
 */
export default function CheckoutOrderThankYouHero({
  className = '',
  compact = false,
  accentColor,
}) {
  const ringColor = accentColor || 'hsl(var(--primary))';

  return (
    <div
      className={cn('flex flex-col items-center text-center', className)}
      data-testid="checkout-thank-you-hero"
      aria-hidden
    >
      <div className="relative mb-3">
        <div
          className={cn(
            'absolute inset-0 rounded-full opacity-20 animate-ping',
            compact ? 'scale-90' : 'scale-100',
          )}
          style={{ backgroundColor: ringColor }}
        />
        <div
          className={cn(
            'relative flex items-center justify-center rounded-full border-2 bg-emerald-50 dark:bg-emerald-950/40 shadow-md animate-in zoom-in-50 duration-500',
            compact ? 'h-16 w-16' : 'h-20 w-20',
          )}
          style={{ borderColor: `${ringColor}55` }}
        >
          <span
            className={cn(
              'inline-block origin-bottom-right animate-[wave_1.2s_ease-in-out_infinite]',
              compact ? 'text-3xl' : 'text-4xl',
            )}
            role="img"
            aria-label="saludo"
          >
            🙌
          </span>
        </div>
      </div>
      <style>{`
        @keyframes wave {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(14deg); }
          75% { transform: rotate(-8deg); }
        }
      `}</style>
    </div>
  );
}
